export default {
  "content": "<rect width=\"193\" height=\"172\" fill=\"#F7F7F7\" rx=\"5\"/><path fill=\"#fff\" d=\"M15 17a8 8 0 018-8h147a8 8 0 018 8v155H15V17z\"/><path fill=\"#C4C4C4\" d=\"M15 15a6 6 0 016-6h151a6 6 0 016 6H15z\" opacity=\".6\"/><path fill=\"#DCDCDC\" d=\"M15 45h163v60H15zm0 114h163v13H15z\"/><rect width=\"31\" height=\"13\" x=\"81\" y=\"22\" fill=\"#DCDCDC\" rx=\"6.5\"/><path fill=\"#DCDCDC\" d=\"M60 121h73v3H60zm-19 8h111v2H41zm0 4h111v2H41zm0 4h111v2H41zm0 4h111v2H41z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "193",
    "height": "172",
    "fill": "none",
    "viewBox": "0 0 193 172"
  }
};